module.exports = __webpack_public_path__ + "static/media/admin-icon.fb867bde.svg";